/*
 * Aankondigingsbalk. Vervangt de app Essential Announcement Bar, die hiervoor
 * glide.min.js meebracht plus zijn eigen script.
 *
 * Wat het doet: boodschappen laten wisselen, pijltjes en kruisje bedienen, en
 * onthouden dat iemand heeft weggeklikt.
 *
 * Wat het bewust NIET doet: schuiven. Een schuivende carrousel is tijdens de
 * beweging zo breed als alle boodschappen samen en duwt de pagina opzij. Hier
 * liggen ze op elkaar en wisselt alleen de dekking.
 */
(function () {
  var root = document.querySelector('[data-sa]');
  if (!root) return;

  var slides = Array.prototype.slice.call(root.querySelectorAll('[data-sa-slide]'));
  var closeButton = root.querySelector('[data-sa-close]');
  var prevButton = root.querySelector('[data-sa-prev]');
  var nextButton = root.querySelector('[data-sa-next]');

  /* ------------------------------------------------------------ wegklikken -- */

  var key = root.dataset.saKey;

  function isDismissed() {
    try {
      return window.localStorage.getItem(key) === '1';
    } catch (error) {
      // Safari in privemodus gooit hier. Dan onthouden we het gewoon niet.
      return false;
    }
  }

  function remember() {
    try {
      window.localStorage.setItem(key, '1');
    } catch (error) {
      /* zie isDismissed */
    }
  }

  /*
   * De sleutel bevat een hash van alle teksten. Verandert er een boodschap, dan
   * is de sleutel anders en is de balk weer zichtbaar -- anders mist iemand die
   * ooit heeft weggeklikt elke volgende actie. Oude sleutels ruimen we hier op
   * zodat localStorage niet volloopt.
   */
  function forgetOtherKeys() {
    try {
      var stale = [];
      for (var i = 0; i < window.localStorage.length; i += 1) {
        var name = window.localStorage.key(i);
        if (name && name.indexOf('sa-dismissed-') === 0 && name !== key) stale.push(name);
      }
      stale.forEach(function (name) {
        window.localStorage.removeItem(name);
      });
    } catch (error) {
      /* niet erg */
    }
  }

  if (isDismissed()) {
    root.hidden = true;
    return;
  }

  forgetOtherKeys();

  if (closeButton) {
    closeButton.addEventListener('click', function () {
      root.hidden = true;
      remember();
      /*
       * De header schuift omhoog nu de balk weg is. Dat melden we, zodat een
       * plakkende header zijn eigen hoogte opnieuw kan meten.
       */
      document.dispatchEvent(new CustomEvent('sentir:announcement:closed'));
    });
  }

  /* -------------------------------------------------------------- wisselen -- */

  if (slides.length < 2) return;

  var index = 0;
  var timer = null;

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var seconds = parseInt(root.dataset.saInterval, 10);
  var interval = (isNaN(seconds) ? 5 : seconds) * 1000;

  function show(next) {
    index = (next + slides.length) % slides.length;

    slides.forEach(function (slide, i) {
      var active = i === index;
      slide.classList.toggle('is-active', active);
      /*
       * aria-hidden op de verborgen boodschappen: zonder dat leest een
       * schermlezer alle drie de teksten achter elkaar voor, terwijl er maar
       * één in beeld staat.
       */
      if (active) slide.removeAttribute('aria-hidden');
      else slide.setAttribute('aria-hidden', 'true');
    });
  }

  function start() {
    /* Wie beweging heeft uitgezet, krijgt geen automatisch doordraaien. */
    if (reduced.matches) return;
    stop();
    timer = window.setInterval(function () {
      show(index + 1);
    }, interval);
  }

  function stop() {
    if (timer) window.clearInterval(timer);
    timer = null;
  }

  /*
   * Handmatig bladeren zet het automatisch doordraaien opnieuw op nul. Anders
   * springt de balk vlak na een klik alsnog door, en lijkt het alsof je knop
   * iets anders deed dan je dacht.
   */
  function step(delta) {
    show(index + delta);
    start();
  }

  if (prevButton) prevButton.addEventListener('click', function () { step(-1); });
  if (nextButton) nextButton.addEventListener('click', function () { step(1); });

  /* Stilzetten zolang iemand kijkt of met het toetsenbord binnen is. */
  root.addEventListener('mouseenter', stop);
  root.addEventListener('mouseleave', start);
  root.addEventListener('focusin', stop);
  root.addEventListener('focusout', start);

  /* Een balk die doordraait in een tabblad op de achtergrond is verspilling. */
  document.addEventListener('visibilitychange', function () {
    if (document.hidden) stop();
    else start();
  });

  if (reduced.addEventListener) {
    reduced.addEventListener('change', function () {
      if (reduced.matches) stop();
      else start();
    });
  }

  start();
})();
